import {
  useQuery,
  useMutation,
  useQueryClient
} from '@tanstack/react-query'

import { jointScenarioQueryKeys } from '../queryKeys'
import { resourcefulJointScenarioRequest } from '../requests'
import { executeRequest } from '@utils/requests'

export function useNotesQuery({
  jointScenarioId,
  initialData,
  queryKey
}) {
  const queryClient = useQueryClient()
  // NOTE: We should contain a list of scenario resources
  // and reference notes from there
  const noteRequests = resourcefulJointScenarioRequest(
    jointScenarioId, 'notes'
  )

  const notesQuery = useQuery({
    queryFn: noteRequests.index,
    queryKey,
    initialData
  })

  const createNoteMutation = useMutation({
    mutationFn: noteRequests.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [jointScenarioQueryKeys.notes] })
    },
  })
  const updateNoteMutation = useMutation({
    mutationFn: noteRequests.update,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [jointScenarioQueryKeys.notes] })
    },
  })
  const deleteNoteMutation = useMutation({
    mutationFn: noteRequests.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [jointScenarioQueryKeys.notes] })
    },
  })

  const importNotesMutation = useMutation({
    mutationFn: (params) => executeRequest(`/api/joint_plans/${jointScenarioId}/notes/import`, 'POST', JSON.stringify(params)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [jointScenarioQueryKeys.notes] })
    },
  })


  const isFetching = notesQuery.isFetching

  const isAnyLoading = notesQuery.isFetching ||
    createNoteMutation.isLoading

  return {
    data: notesQuery.data,
    actions: {
      create: createNoteMutation.mutateAsync,
      update: updateNoteMutation.mutateAsync,
      delete: deleteNoteMutation.mutateAsync,
      importSources: () => executeRequest(`/api/joint_plans/${jointScenarioId}/notes/import_sources`),
      import: importNotesMutation.mutateAsync,
    },
    status: notesQuery.status,

    /* Boolean flags indicating various states of status */
    isFetching: isFetching,
    isAnyLoading: isAnyLoading
  }
}
